define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/FWpAssetAttr", "../entity/FWpAssetReplace", "../domain", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, FWpAssetAttr_1, FWpAssetReplace_1, domain_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpAsset = void 0;
    class FWpAsset extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WpId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WpIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EnhanceFAssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EnhanceFAssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewAssetTypeId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewAssetTypeIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Cost", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CostError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Barcode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BarcodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Qty", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QtyError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingLife", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingLifeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLife", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLifeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpAssetAttr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFWpAssetAttr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpAssetAttrError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpAssetReplace", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFWpAssetReplace", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpAssetReplaceError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWorksProject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemLifeYears", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedRemLifeYears", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedRemLifeMonths", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FWpAsset.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FWorksProject = parent;
            this.WpId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.FWpAssetAttr = [];
            this.FWpAssetReplace = [];
        }
        onRead(entity, parent) {
            this.FWorksProject = parent;
            this.FWpAssetAttr = [];
            this.FWpAssetReplace = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WpId = (0, EntityUtil_1.toInt)(entity.WpId);
            a.ChangeType = (0, EntityUtil_1.toInt)(entity.ChangeType);
            a.EnhanceFAssetId = (0, EntityUtil_1.toInt)(entity.EnhanceFAssetId);
            a.NewAssetTypeId = (0, EntityUtil_1.toInt)(entity.NewAssetTypeId);
            a.Cost = (0, EntityUtil_1.toFloat)(entity.Cost);
            a.Barcode = b.Barcode;
            a.Qty = (0, EntityUtil_1.toInt)(entity.Qty);
            a.RemainingLife = (0, EntityUtil_1.toInt)(entity.RemainingLife);
            a.SuggestedLife = (0, EntityUtil_1.toInt)(entity.SuggestedLife);
            a.FWpAssetAttr = this.mergeArray(a.FWpAssetAttr, b.FWpAssetAttr, FWpAssetAttr_1.FWpAssetAttr);
            a.SelectedFWpAssetAttr = a.SelectedFWpAssetAttr && a.FWpAssetAttr.find(x => x.Id == a.SelectedFWpAssetAttr.Id) ? a.SelectedFWpAssetAttr : null;
            a.FWpAssetReplace = this.mergeArray(a.FWpAssetReplace, b.FWpAssetReplace, FWpAssetReplace_1.FWpAssetReplace);
            a.SelectedFWpAssetReplace = a.SelectedFWpAssetReplace && a.FWpAssetReplace.find(x => x.Id == a.SelectedFWpAssetReplace.Id) ? a.SelectedFWpAssetReplace : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.addChangeEventAction("EnhanceFAssetId", this.updateAssetAttributes.bind(this));
            this.addChangeEventAction("NewAssetTypeId", this.updateAssetAttributes.bind(this));
            this.RemLifeYears = Math.floor(this.RemainingLife / 12);
            this.SuggestedRemLifeYears = Math.floor(this.SuggestedLife / 12);
            this.SuggestedRemLifeMonths = this.SuggestedLife % 12;
            this.addChangeEventAction("RemLifeYears", this.onRemLifeYearChange.bind(this));
            this.addChangeEventAction("SuggestedRemLifeYears", this.onSuggestedLifeYearChange.bind(this));
            this.addChangeEventAction("SuggestedRemLifeMonths", this.onSuggestedLifeMonthChange.bind(this));
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FWpAsset.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WpId", "Works Project ID");
                this.validateReqNumber(validationState, "ChangeType", "Change Type");
                this.validateReqNumber(validationState, "Cost", "Cost of Change", { precision: 2 });
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.FWpAssetAttr) {
                for (let x of this.FWpAssetAttr) {
                    x.walk(func, { leading });
                }
            }
            if (this.FWpAssetReplace) {
                for (let x of this.FWpAssetReplace) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WpId: this.WpId,
                ChangeType: this.ChangeType,
                EnhanceFAssetId: this.EnhanceFAssetId,
                NewAssetTypeId: this.NewAssetTypeId,
                Cost: this.Cost,
                Barcode: this.Barcode,
                Qty: this.Qty,
                RemainingLife: this.RemainingLife,
                SuggestedLife: this.SuggestedLife,
                FWpAssetAttr: this.FWpAssetAttr.map(x => x.toJson()),
                FWpAssetReplace: this.FWpAssetReplace.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(wp, assetType) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating New Works Asset");
                services_1.SrmsServiceManager.Instance.Facility.createNewFacilityAsset(wp.Id, assetType.toJson()).then(a => {
                    let x = new FWpAsset(a, wp);
                    wp.FWpAsset.push(x);
                    resolve(x);
                });
            });
        }
        static enhance(wp, asset) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating Enhanced Works Asset");
                services_1.SrmsServiceManager.Instance.Facility.enhanceFacilityAsset(wp.Id, asset.toJson()).then(a => {
                    let x = new FWpAsset(a, wp);
                    wp.FWpAsset.push(x);
                    resolve(x);
                });
            });
        }
        static replace(a, assetToReplace) {
            return new Promise((resolve, reject) => {
                var existingAssetReplacementRecord = a.FWpAssetReplace.find(a => a.FAssetId == assetToReplace.Id);
                if (!existingAssetReplacementRecord) {
                    (0, EventManager_1.notify)("Replacing an existing asset");
                    services_1.SrmsServiceManager.Instance.Facility.replaceExistingFacilityAsset(a.Id, assetToReplace.Id, false).then(r => {
                        let x = new FWpAssetReplace_1.FWpAssetReplace(r, a);
                        a.FWpAssetReplace.push(x);
                        resolve(x);
                    });
                }
            });
        }
        get EnhanceFAsset() {
            if (this.ChangeType == domain_1.FWpAssetChangeTypeDomain.EnhanceAsset) {
                if (this.FWorksProject && this.FWorksProject.Facility) {
                    return this.FWorksProject.Facility.FAsset.find(a => a.Id == this.EnhanceFAssetId);
                }
            }
            return null;
        }
        onRemLifeYearChange() {
            this.RemainingLife = (this.RemLifeYears * 12);
        }
        onSuggestedLifeYearChange() {
            this.SuggestedLife = (this.SuggestedRemLifeYears * 12) + this.SuggestedRemLifeMonths;
        }
        onSuggestedLifeMonthChange() {
            this.SuggestedLife = (this.SuggestedRemLifeYears * 12) + this.SuggestedRemLifeMonths;
        }
        get AssetType() {
            if (this.FWorksProject && this.FWorksProject.Facility && this.FWorksProject.Facility.AssetTypes) {
                if (this.ChangeType == domain_1.FWpAssetChangeTypeDomain.NewAsset) {
                    return this.FWorksProject.Facility.AssetTypes.find(at => at.Id == this.NewAssetTypeId);
                }
                else if (this.ChangeType == domain_1.FWpAssetChangeTypeDomain.EnhanceAsset) {
                    return this.FWorksProject.Facility.AssetTypes.find(at => at.Id == this.EnhanceFAsset.AssetTypeId);
                }
            }
            return null;
        }
        get TypeDesc() {
            if (this.AssetType) {
                return this.AssetType.AssetTypeDesc;
            }
            else {
                return "";
            }
        }
        get ApplicableAssetAttributes() {
            let assetType = this.AssetType;
            if (this.FWorksProject.Facility.AssetAttributeTypes) {
                return this.FWorksProject.Facility.AssetAttributeTypes.filter(aat => {
                    return (aat.AssetGroup == assetType.AssetGroup) && (aat.AssetDesc == assetType.AssetDesc || aat.AssetDesc == null || aat.AssetDesc.trim().length == 0);
                });
            }
            else {
                return [];
            }
        }
        get UnassignedAttributeTypes() {
            return this.ApplicableAssetAttributes.filter(aa => {
                return !this.IsAttributeTypeAssigned(aa);
            });
        }
        IsAttributeTypeAssigned(type) {
            return this.FWpAssetAttr.findIndex((aa) => aa.AttrTypeId == type.Id) > -1;
        }
        updateAssetAttributes() {
            for (let i = this.FWpAssetAttr.length - 1; i >= 0; i--) {
                let attr = this.FWpAssetAttr[i];
                if (attr.AssetAttributeType.AssetGroup != this.AssetType.AssetGroup) {
                    if (attr.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                        this.FWpAssetAttr.splice(i, 1);
                    }
                    else {
                        attr.markForDeletion();
                    }
                }
                else {
                    if (attr.PersistanceState == EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                        attr.PersistanceState = attr.PersistanceStateBeforeDelete;
                    }
                }
            }
        }
    }
    exports.FWpAsset = FWpAsset;
    Object.defineProperty(FWpAsset, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FWpAsset"
    });
    Object.defineProperty(FWpAsset, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Works Project Job Asset"
    });
    Object.defineProperty(FWpAsset, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WpId", "ChangeType", "EnhanceFAssetId", "NewAssetTypeId", "Cost", "Barcode", "Qty", "RemainingLife", "SuggestedLife"]
    });
    Object.defineProperty(FWpAsset, "WpIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpAsset, "ChangeTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpAsset, "ChangeTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpAsset, "EnhanceFAssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpAsset, "NewAssetTypeIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpAsset, "CostReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpAsset, "BarcodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpAsset, "BarcodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpAsset, "QtyReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpAsset, "RemainingLifeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpAsset, "SuggestedLifeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "WpId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "WpIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "ChangeType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "ChangeTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "EnhanceFAssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "EnhanceFAssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "NewAssetTypeId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "NewAssetTypeIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "Cost", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "CostError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "Barcode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "BarcodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "Qty", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "QtyError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "RemainingLife", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "RemainingLifeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "SuggestedLife", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "SuggestedLifeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "FWpAssetAttr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "SelectedFWpAssetAttr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "FWpAssetAttrError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "FWpAssetReplace", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "SelectedFWpAssetReplace", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "FWpAssetReplaceError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "FWorksProject", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpAsset.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpAsset.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpAsset.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "RemLifeYears", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "SuggestedRemLifeYears", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAsset.prototype, "SuggestedRemLifeMonths", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAsset.prototype, "EnhanceFAsset", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAsset.prototype, "AssetType", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAsset.prototype, "TypeDesc", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAsset.prototype, "ApplicableAssetAttributes", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAsset.prototype, "UnassignedAttributeTypes", null);
});
